import type { QueryKey } from '@tanstack/react-query'

const appSettings: QueryKey = ['appSettings']

export { appSettings }
